import { useEffect, useState } from "react";
import styled from "styled-components";
import * as Library from "../../../../utils/Library";
import BtnLargeSolid from "../../../common/buttons/BtnLargeSolid";
import CardComponentContainer from "../../../common/cardContainers/CardComponentContainer";
import { POS_INTEGRATED } from "../POSConfigPage";
import CheckboxVector from "../../../common/checkbox/CheckboxVector";

// #region SCOPED CSS
const StyledPage = styled.div`
    // First Requirement CSS
    .frame-1000011459 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .i-m-subscribed-to-the-front-systems-xl-plan {
        text-align: left;
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        align-self: stretch;
    }
    .only-the-xl-version-or-higher-is-able-to-activate-the-omnichannel-capability-if-you-run-any-version-lower-than-xl-please-contact-front-systems-support {
        text-align: left;
        font-size: 12px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }

    // Second Requirement CSS
    .frame-1000011460 {
        display: flex;
        flex-direction: row;
        gap: 25px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011459 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .complete-the-front-systems-form-to-get-an-api-key-granting-b-otag-access-to-your-pos {
        text-align: left;
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        align-self: stretch;
    }
    .when-you-click-the-go-to-form-button-you-ll-be-redirected-to-front-systems-form-to-request-api-access-to-b-otag-once-approved-front-systems-will-provide-you-with-an-api-key-copy-this-key-and-paste-it-into-the-api-key-field-below {
        text-align: left;
        font-size: 12px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }

    // Third Requirement CSS
    .frame-1000011459 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .request-front-systems-to-create-a-virtual-store-for-b-otag-in-your-system-and-provide-you-with-the-virtual-store-id {
        text-align: left;
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        align-self: stretch;
    }
    .the-virtual-store-id-is-required-to-integrate-with-hey-bo-hey-bo-is-the-b-otag-consumer-app-that-delivers-customers-orders-directly-to-your-pos-already-paid-and-ready-for-delivery {
        text-align: left;
        font-size: 12px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
`;

const CheckboxWithContentStyle = styled.div`
    &.step-card,
    &.step-card * {
        box-sizing: border-box;
    }
    &.step-card {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 16px;
        padding: 16px 24px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        backdrop-filter: blur(50px);
        border: 1px solid transparent;
    }

    // State: inactive — greyed out, no interaction
    &.state-inactive {
        cursor: not-allowed;
    }
    &.state-inactive .title,
    &.state-inactive .checkboxDescription {
        color: var(--text-icons-gray-300, #4f5b6d);
    }

    // State: active — highlighted border, current step
    &.state-active {
        border: 1px solid var(--App-Accent-Outline);
    }
    &.state-active .title,
    &.state-active .checkboxDescription {
        color: var(--text-icons-gray-100, #d1d1d1);
        cursor: pointer;
    }

    // State: completed — greyed out, but still clickable to rewind
    &.state-completed .title,
    &.state-completed .checkboxDescription {
        color: var(--text-icons-gray-300, #4f5b6d);
        cursor: pointer;
    }

    .step-header-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 26px;
        width: 100%;
    }
    .step-checkbox-row {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .title,
    .checkboxDescription {
        color: var(--text-icons-gray-300, #4f5b6d);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }
`;
// #endregion

/**
 * Requirements Card Component
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {boolean} props.requirementsActive - Whether the requirements card is active (interactive).
 * @param {Object} props.selectedPOS - The selected POS configuration.
 * @param {boolean} props.requirementsCompleted - Whether all requirement steps are completed (view-only mode).
 * @param {function} props.setRequirementsCompleted - Function to update the requirementsCompleted state.
 * @param {function} props.onRequirementsClickContinue - Handler for the continue action.
 */
export const RequirementsCard = ({
    requirementsActive,
    selectedPOS,
    requirementsCompleted,
    setRequirementsCompleted,
    onRequirementsClickContinue
}) => {
    // #region VARS
    const [posNumOfSteps, setPosNumOfSteps] = useState(null);
    const [posCurrentStep, setPosCurrentStep] = useState(null);
    const [posSteps, setPosSteps] = useState([]);
    // #endregion

    // #region CHECKBOX METHODS
    const getStepState = stepNum => {
        if (posNumOfSteps === null) return "inactive";
        if (posCurrentStep < stepNum) return "inactive";
        if (posCurrentStep === stepNum) return "active";
        return "completed"; // posCurrentStep > stepNum
    };

    const isStepChecked = stepNum => {
        if (posNumOfSteps === null) return false;
        if (posCurrentStep < stepNum) return false;
        if (posCurrentStep === stepNum) return !!posSteps[stepNum];
        return true;
    };

    const onCheckboxClick = stepClickNum => {
        if (posNumOfSteps === null) return;

        // Clicking the current step -> advance
        if (posCurrentStep === stepClickNum) {
            const newSteps = [...posSteps];
            newSteps[stepClickNum] = true;
            setPosSteps(newSteps);
            setPosCurrentStep(stepClickNum + 1);
            return;
        }

        // Clicking a previous step -> rewind
        if (posCurrentStep > stepClickNum) {
            const newSteps = posSteps.map((step, index) => {
                if (index < stepClickNum) return step;
                return false;
            });
            setPosSteps(newSteps);
            setPosCurrentStep(stepClickNum);
        }
    };

    const sendEmailClicked = async () => {
        const retailer_brand_name = JSON.parse(localStorage.getItem("retailBrands"))?.[0]?.name;
        const retailer_brand_user = localStorage.getItem("userName");
        const toEmail = selectedPOS?.emailSupport;
        const companyName = localStorage.getItem("currentCompanyName") ?? "[Company]";

        const subject = "BOtag Virtual Store ID request";
        const body = `Hello Front Systems team,\n        
                      We enrolled ${companyName} in BOtag. In order to finalize integration with Front Systems, please create our Virtual Store ID and send it back to us when ready\n
                      Best regards,
                      ${retailer_brand_user}
                      ${retailer_brand_name}`;

        window.open(`mailto:${toEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
    };
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        if (!selectedPOS) return;

        if (selectedPOS?.value === POS_INTEGRATED.FRONT_SYSTEMS) {
            const numSteps = 3;
            setPosNumOfSteps(numSteps);

            if (requirementsCompleted) {
                // View-only mode: all steps pre-checked
                setPosCurrentStep(numSteps);
                setPosSteps(Array(numSteps).fill(true));
            } else {
                // Interactive mode: start from step 0
                setPosCurrentStep(0);
                setPosSteps([]);
            }
        } else {
            setPosNumOfSteps(null);
            setPosCurrentStep(null);
            setPosSteps([]);
        }
    }, [selectedPOS?.value]);

    useEffect(() => {
        if (posNumOfSteps === null || posCurrentStep === null) {
            setRequirementsCompleted(false);
            return;
        }

        const allCompleted =
            posCurrentStep >= posNumOfSteps && posSteps.length === posNumOfSteps && posSteps.every(s => s === true);
        setRequirementsCompleted(allCompleted);
    }, [posCurrentStep, posNumOfSteps, posSteps]);
    // #endregion

    // #region RENDER
    return (
        <StyledPage>
            <CardComponentContainer title="REQUIREMENTS" spacing="16px">
                {selectedPOS &&
                    (selectedPOS?.value === "other" || selectedPOS?.value === "653122e4a2673ea91c967c5b") && (
                        <div className="flex flex-col gap-16px">Not Integrated</div>
                    )}

                {selectedPOS && selectedPOS?.value === POS_INTEGRATED.FRONT_SYSTEMS && (
                    <div
                        className="flex flex-column gap-16px"
                        style={{
                            borderRadius: "10px",
                            border: "1px solid var(--backgrounds-lines-n-100, #3C485A)",
                            padding: "16px",
                            marginTop: "24px"
                        }}>
                        <CheckboxWithContent
                            description={`
                            <div class="frame-1000011459">
                                <div class="i-m-subscribed-to-the-front-systems-xl-plan">
                                    I'm subscribed to the Front Systems XL plan.
                                </div>
                                <div class="only-the-xl-version-or-higher-is-able-to-activate-the-omnichannel-capability-if-you-run-any-version-lower-than-xl-please-contact-front-systems-support">
                                    Only the XL version (or higher) is able to activate the omnichannel capability. If
                                    you run any version lower than XL, please contact Front Systems support.
                                </div>
                            </div>`}
                            state={!requirementsActive ? "inactive" : getStepState(0)}
                            isChecked={isStepChecked(0)}
                            onCheckboxClick={() => onCheckboxClick(0)}
                        />

                        <CheckboxWithContent
                            headerTitle={`<div class="frame-1000011460">
                            <div class="frame-1000011459">
                                <div
                                class="complete-the-front-systems-form-to-get-an-api-key-granting-b-otag-access-to-your-pos"
                                >
                                Complete the Front Systems form to get an API key granting BOtag access to
                                your POS.
                                </div>
                                <div
                                class="when-you-click-the-go-to-form-button-you-ll-be-redirected-to-front-systems-form-to-request-api-access-to-b-otag-once-approved-front-systems-will-provide-you-with-an-api-key-copy-this-key-and-paste-it-into-the-api-key-field-below"
                                >
                                When you click the Go to Form button, you'll be redirected to Front
                                Systems' form to request API access to BOtag. Once approved, Front Systems
                                will provide you with an API key. Copy this key and paste it into the API
                                key field below.
                                </div>
                            </div>
                        </div>`}
                            description="I received the API Key"
                            rightButton={{
                                title: "GO TO FORM",
                                onClick: () => {
                                    Library.openNewPage(
                                        "https://frontsystems.wufoo.com/forms/z1463mt51l4iseg&sa=D&source=editors&ust=1723630453977729&usg=AOvVaw1I2LAby2B5xBeDnzWmzSGO"
                                    );
                                }
                            }}
                            state={!requirementsActive ? "inactive" : getStepState(1)}
                            isChecked={isStepChecked(1)}
                            onCheckboxClick={() => onCheckboxClick(1)}
                        />

                        <CheckboxWithContent
                            headerTitle={`<div class="frame-1000011459">
                            <div
                                class="request-front-systems-to-create-a-virtual-store-for-b-otag-in-your-system-and-provide-you-with-the-virtual-store-id"
                            >
                                Request Front Systems to create a virtual store for BOtag in your system and
                                provide you with the Virtual Store ID.
                            </div>
                            <div
                                class="the-virtual-store-id-is-required-to-integrate-with-hey-bo-hey-bo-is-the-b-otag-consumer-app-that-delivers-customers-orders-directly-to-your-pos-already-paid-and-ready-for-delivery"
                            >
                                The Virtual Store ID is required to integrate with heyBO. heyBO is the BOtag
                                consumer app that delivers customers' orders directly to your POS, already
                                paid and ready for delivery.
                            </div>
                        </div>`}
                            description="I received the Virtual Store ID"
                            rightButton={{
                                title: "SEND EMAIL",
                                onClick: () => sendEmailClicked()
                            }}
                            state={!requirementsActive ? "inactive" : getStepState(2)}
                            isChecked={isStepChecked(2)}
                            onCheckboxClick={() => onCheckboxClick(2)}
                        />
                    </div>
                )}

                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "32px" }}>
                    <BtnLargeSolid
                        title="CONTINUE"
                        onClick={onRequirementsClickContinue}
                        disabled={!requirementsCompleted || !requirementsActive}
                        normalColor="var(--App-Accent-Active)"
                        hoverColor="var(--App-Accent-Hover)"
                        activeColor="var(--App-Accent-Active)"
                        disabledColor="var(--Buttons-All-Platforms-Gray-500, #10141b)"
                        textStyle={{ fontSize: "12px" }}
                        style={{ width: "150px", marginRight: "40px" }}
                    />
                </div>
            </CardComponentContainer>
        </StyledPage>
    );
    // #endregion
};

// #region SMALL COMPONENTS
/**
 * CheckboxWithContent - A step card with a checkbox, optional header and optional right button.
 *
 * @param {"inactive" | "active" | "completed"} state
 *   - "inactive": greyed out, no interaction allowed
 *   - "active": current step, highlighted border, clickable to advance
 *   - "completed": already done, greyed out, but still clickable to rewind
 * @param {boolean} isChecked - Whether the checkbox is visually checked
 * @param {function} onCheckboxClick - Called when checkbox or description is clicked
 * @param {string} headerTitle - HTML string for the header area
 * @param {string} description - HTML string for the checkbox label
 * @param {{ title: string, onClick: function }} rightButton - Optional action button in the header
 */
const CheckboxWithContent = ({
    state = "inactive",
    isChecked,
    onCheckboxClick,
    headerTitle,
    description,
    rightButton
}) => {
    const isInteractive = state === "active" || state === "completed";
    const rightButtonDisabled = state !== "active" || isChecked;

    const handleClick = () => {
        if (isInteractive && onCheckboxClick) onCheckboxClick();
    };

    return (
        <CheckboxWithContentStyle className={`step-card state-${state}`}>
            {(headerTitle || rightButton) && (
                <div className="step-header-row">
                    {headerTitle && (
                        <div
                            className="title"
                            dangerouslySetInnerHTML={{ __html: headerTitle }}
                            style={{ flexGrow: 1 }}
                            onClick={handleClick}
                        />
                    )}

                    {rightButton && (
                        <BtnLargeSolid
                            title={rightButton.title}
                            onClick={rightButton.onClick}
                            disabled={rightButtonDisabled}
                            normalColor="var(--App-Accent-Active)"
                            hoverColor="var(--App-Accent-Hover)"
                            activeColor="var(--App-Accent-Active)"
                            textStyle={{ fontSize: "12px" }}
                            style={{ width: "150px" }}
                        />
                    )}
                </div>
            )}

            <div className="step-checkbox-row">
                <CheckboxVector
                    isChecked={isChecked}
                    onCheckboxClick={handleClick}
                    disabled={!isInteractive}
                    className="mr-4px"
                    style={{ alignSelf: "start" }}
                />
                <div
                    className="checkboxDescription"
                    onClick={handleClick}
                    dangerouslySetInnerHTML={{ __html: description }}
                    style={{ flexGrow: 1 }}
                />
            </div>
        </CheckboxWithContentStyle>
    );
};
// #endregion
